import { Component } from 'react';

class HomePlayFormErrorConsole extends Component {
  render() {
    const { errors, show } = this.props;

    return (
      <div className="home_play_form_error_console">
        {show && (
          <div className="home_play_form_errors">
            {errors.map((errorMessage) => (
              <div className="home_play_console_error">{errorMessage}</div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default HomePlayFormErrorConsole;
